export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-full md:w-[55%] h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20strip%20and%20movie%20reel%20composition%20with%20warm%20red%20and%20gold%20tones%2C%20soft%20gradient%20lighting%20from%20left%20to%20right%2C%20modern%20clean%20design%2C%20artistic%20illustration%20style%20with%20subtle%20texture%2C%20no%20text%2C%20dark%20moody%20atmosphere%20with%20elegant%20highlights%2C%20film%20celluloid%20border%20motif%2C%20professional%20cinema%20aesthetic&width=900&height=700&seq=hero-cinema-01&orientation=landscape"
            alt="6080影院主题视觉 - 电影胶片与影院氛围"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/30 md:via-background-50/80 md:to-background-50/20"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="py-10 md:py-16">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-fire-line text-sm"></i>
                全网热播
              </span>

              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-100 leading-tight mb-3">
                6080影院 - 高清电影免费看
              </h1>

              <p className="text-base md:text-lg text-primary-500 font-medium mb-6">
                高清视频播放流畅不卡，追剧观影零等待
              </p>

              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8 max-w-lg">
                6080影院是全网领先的高清在线影院平台，汇集海量高清电影免费看与免费电视剧全集资源。
                每日精选热门影视持续更新，支持多线路高清视频播放，为您打造流畅不卡的居家观影体验。
                无论是最新院线大片还是经典剧集，这里都是您触手可及的免费影视大全。
              </p>

              <div className="flex flex-wrap gap-6 mb-8">
                <div className="flex items-center gap-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-movie-line text-accent-600 text-base"></i>
                  </span>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">20000+</div>
                    <div className="text-xs text-foreground-500">影视资源</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-timer-flash-line text-primary-600 text-base"></i>
                  </span>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">每日50+</div>
                    <div className="text-xs text-foreground-500">新片更新</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100">
                    <i className="ri-4k-line text-secondary-600 text-base"></i>
                  </span>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">1080P</div>
                    <div className="text-xs text-foreground-500">高清画质</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#carousel"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始观看
                </a>
                <a
                  href="#features"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300 text-foreground-300 font-medium rounded-lg hover:border-primary-400 hover:text-primary-500 hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer text-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  了解平台优势
                  <i className="ri-arrow-right-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="hidden md:flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20cinema%20streaming%20illustration%20with%20overlapping%20film%20frames%20showing%20various%20movie%20scenes%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20vector%20art%20style%2C%20floating%20elements%20of%20popcorn%20and%20film%20reels%2C%20soft%20gradient%20background%2C%20no%20text%2C%20playful%20and%20inviting%20composition%2C%20high-quality%20illustration&width=600&height=520&seq=hero-visual-02&orientation=landscape"
                alt="6080影院 - 高清在线观影体验"
                className="w-full max-w-[520px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}